// extracted by mini-css-extract-plugin
module.exports = {"gradient-box-bg":"gradient-box_gradient-box-bg__zxphC","gradient-box-bg-heavy":"gradient-box_gradient-box-bg-heavy__zr9ne"};